<template>
  <section class="section-hero section-shaped my-0">
    <div class="shape shape-style-1" :class="'bg-'+color">
      <span class="span-150"></span>
      <span class="span-50"></span>
      <span class="span-50"></span>
      <span class="span-75"></span>
      <span class="span-100"></span>
      <span class="span-75"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
    </div>
    <div class="container shape-container d-flex align-items-center pt-lg pb-0">
      <div class="col px-0">
        <div class="row justify-content-center align-items-center">
          <div class="col text-center">
            <h1 class="display-1 text-white">
              {{ firstLine }}
              <br>
              {{ secondLine }}
              {{ keyword }}
            </h1>
            <div class="w-lg-50 mx-auto">
              <p class="lead text-white mt-4 mb-5 v0">{{ tagline }}</p>
            </div>
            <div v-if="buttonLink" class="btn-wrapper pb-lg">
              <router-link :to="buttonLink">
                <base-button class="badge-pill border-0 text-white px-sm connect-gradient">
                  <span class="display-4">{{ buttonText }}</span>
                </base-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ConnectButton from "@/views/components/ConnectButton";
export default {
  components: {
    ConnectButton
  },
  props: {
    firstLine: {
      type: String,
      default: ""
    },
    secondLine: {
      type: String,
      default: ""
    },
    keyword: {
      type: String,
      default: ""
    },
    tagline: {
      type: String,
      default: ""
    },
    buttonLink: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary"
    }
  }
};
</script>
